/**
 * @module MfcJsTypes
 * Custom types for www/mobile interopt scripts
 */

/**
 * MfcNewsFeed
 */
export type NewsSelection =
    | 'all_news'
    | 'subscriptions_friends'
    | 'subscriptions'
    | 'all_models'
    | 'myfreecams_news'
    | 'my_news'
    | 'recent_models'
    | 'single_user'
    | 'search'

export type NewsSearchType = 'news' | 'username'
export type NewsUserActions = 'subscriptions' | 'hidden'
export type NewsUserSettings =
    | 'FCNEWSOPT_IN_CHAN' // 1
    | 'FCNEWSOPT_IN_PM' // 2
    | 'FCNEWSOPT_IN_CHAN_NOGRP' // 16
    | 'FCNEWSOPT_IN_CHAN_NOPVT' // 8
    | 'FCNEWSOPT_ADDFRIENDS_OFF' // 4

export type NewsActionsOptions = {
    value: number | boolean
    key: NewsUserActions | NewsUserSettings
}

export type UpdateNewsOptions = {
    show_more?: number
    update_only?: number // "1" will update when new news comes in
    update_from?: any
    callback?(data: any): void
}

export type NewsViewSelectionOptions = {
    selection: string
    online_only: boolean
}

export const NewsSelectionDictionary = {
    subscriptions_friends: 'Following + Friends',
    subscriptions: 'Following',
    all_models: 'All Models News',
    all_news: 'All Models & Members',
    myfreecams_news: 'MyFreeCams News',
    my_news: 'My Posts',
    recent_models: 'Models with News in past 24 hours',
}

export type NewsFeedUser = {
    access_level?: number
    cam_score?: number
    chat_opts?: number
    chat_text_color?: string
    chat_text_font?: number
    font_style?: string
    online?: number
    username?: string
}

export type NewsFeedItem = {
    id?: number
    message?: string
    message_date_epoch?: number
    message_date_pretty?: string
    time_since?: string
    user_id?: number
}

export type NewsFeedResult = {
    message?: null
    news?: Array<NewsFeedItem>
    offset?: number
    size?: string
    users?: {
        [propName: number]: NewsFeedUser
    }
    view_selection?: NewsSelection
    search_key?: string
    search_string?: string
    show_more?: string
}

export type NewsListUser = {
    font_style?: string
    user_id?: number
    username?: string
}

export type NewsInfo = {
    lists?: {
        hidden?: {
            count: number
            list: Array<NewsListUser>
        }
        subscriptions_from?: {
            count: number
            list: Array<NewsListUser>
        }
        subscriptions_to?: {
            count: number
            list: Array<NewsListUser>
        }
    }
    options?: {
        news_feed_options?: number
        share_shout_delete_selected?: number
        share_shout_sync_selected?: any
    }
    self?: {
        access_level?: number
        font_style?: string
        user_id?: number
        username?: string
    }
}

export type NewsLists = {
    ignoredList: Array<NewsListUser>
    followingList: Array<NewsListUser>
    followingMeList: Array<NewsListUser>
}

export type NewsUserAction = (
    type: NewsUserActions,
    userId: number,
    remove?: boolean,
) => void
